export default __webpack_public_path__ + "static/Necoh_Symbole-d366d385fc39310074b6d75b3db16037.png";